import axios from "axios";

const baseApiUrl =
  process.env.REACT_APP_API_LOGIN_URL ||
  "https://api-dev-scoringcapture.lanetalk.com/v1";
const instance = axios.create({
  baseURL: `${baseApiUrl}`,
});

const getAuth = (email, password) => {
  return instance
    .post("/auth/login", { email, password })
    .then(({ data }) => {
      if (data.success === false) {
        return { errors: { password: data && data.message } };
      }
      return data;
    })
    .catch((e) => e && e.response?.data);
};

const verifyAccount = (code) => {
  return instance
    .get(`/auth/verify/${code}`)
    .then(({ data }) => {
      if (data.success === false) {
        return { errors: { password: data && data.message } };
      }
      return data;
    })
    .catch((e) => e && e.response?.data);
};

const sendForgotPassword = (email) => {
  return instance
    .post("/auth/recovery", { email })
    .then(({ data }) => {
      if (data.success === false) {
        return { errors: { email: data.message } };
      }
      return data;
    })
    .catch((e) => e.response.data);
};

const resetPassword = (data) => {
  return instance
    .put("/auth/recovery", data)
    .then(({ data }) => {
      return data;
    })
    .catch((e) => e.response.data);
};

const logout = async ({ access_token }) => {
  try {
    const { data } = await instance.post(
      "/auth/revoke",
      { token: access_token },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return data;
  } catch (e) {
    return e && e.response?.data;
  }
};

export { getAuth, sendForgotPassword, resetPassword, logout, verifyAccount };
